import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=b362ec6a&scoped=true"
import script from "./archived.vue?vue&type=script&lang=js"
export * from "./archived.vue?vue&type=script&lang=js"
import style0 from "./archived.vue?vue&type=style&index=0&id=b362ec6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b362ec6a",
  null
  
)

export default component.exports